import { createSignal, JSXElement, mergeProps, Show } from 'solid-js';
import { CustomerPortalHeader } from '~/components/Layout/Header';
import { isLoadedInIframe } from '~/utils/commonUtils.ts';
import { CustomerPortalPageTypes } from '~/components/Layout/utils.tsx';
import TwoColumnDraggableContainer from '~/components/Layout/TwoColumnDraggableContainer.tsx';
import NeedHelpDocContent from '~/components/Layout/NeedHelp/NeedHelpDocContent.tsx';
import { useScalekitWatermarkVisibility } from '../ScalekitWatermark';
import ScalekitWatermark from '../ScalekitWatermark/ScalekitWatermark.tsx';

type CustomerPortalLayoutProps = {
  children: JSXElement;
  pageType?: CustomerPortalPageTypes;
};

export default function AdminPortalLayout(
  props: CustomerPortalLayoutProps
): JSXElement {
  const merged = mergeProps(
    {
      pageType: CustomerPortalPageTypes.SSO_CONFIGURATION
    },
    props
  );

  const { shouldShowWatermark } = useScalekitWatermarkVisibility();

  const [showHelpSection, setShowHelpSection] = createSignal(false);

  const isRenderingDocs = () =>
    merged.pageType === CustomerPortalPageTypes.DOCUMENTATION;

  return (
    <div class={`flex justify-center`}>
      <TwoColumnDraggableContainer
        leftContent={
          <div
            class={`min-h-screen mx-auto bg-bg-default relative flex flex-col`}
            classList={{
              'px-8': !isRenderingDocs(),
              '!w-full': isRenderingDocs() || isLoadedInIframe(),
              'w-10/12 xl:w-8/12':
                !isRenderingDocs() && !showHelpSection() && !isLoadedInIframe(),
              'container': !isRenderingDocs() && showHelpSection(),
              'border-r border-r-border-muted border-l border-l-border-muted':
                !isLoadedInIframe()
            }}
            data-main-container="true"
          >
            <Show when={!isLoadedInIframe()}>
              <CustomerPortalHeader
                pageType={merged.pageType}
                isHelpDisplayed={showHelpSection()}
                onClickNeedHelp={() =>
                  setShowHelpSection((isHelpDisplayed) => !isHelpDisplayed)
                }
              />
            </Show>
            <div
              classList={{
                'pt-8 pb-4': !isRenderingDocs(),
                'w-full': isRenderingDocs(),
                '!pb-0': shouldShowWatermark()
              }}
              class={`flex-1`}
            >
              {merged.children}
            </div>
            <Show when={shouldShowWatermark()}>
              <div class="sticky bottom-0 left-0 right-0 w-calc(100%+4rem) -mx-8">
                <ScalekitWatermark class="mx-auto" />
              </div>
            </Show>
          </div>
        }
        rightContent={showHelpSection() && <NeedHelpDocContent />}
      />
    </div>
  );
}
